import { render } from "./BasePopOver.vue?vue&type=template&id=ef0da852&scoped=true"
import script from "./BasePopOver.vue?vue&type=script&lang=js"
export * from "./BasePopOver.vue?vue&type=script&lang=js"

import "./BasePopOver.vue?vue&type=style&index=0&id=ef0da852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0da852"]])

export default __exports__